import { createApi } from "@reduxjs/toolkit/query/react";
import { apiBaseQuery } from "../utils/apiBaseQuery";
import { CollectionPayloadInterface } from "../interfaces/collections/CollectionInterface";

export type { CollectionPayloadInterface };

export const collectionsApiSlice = createApi({
    reducerPath: "collectionsApi",
    baseQuery: apiBaseQuery(),
    tagTypes: ["Collections"],
    endpoints: (builder) => ({
        getCollections: builder.query<CollectionPayloadInterface[], void>({
            query: () => "apiV2/dealer/collections",
            transformResponse: (response: {
                data: CollectionPayloadInterface[];
            }) => response.data,
            providesTags: ["Collections"],
        }),
        createCollection: builder.mutation<
            void,
            { collectionName: string; productIds: number[] }
        >({
            query: (params) => ({
                url: "apiV2/dealer/collections",
                method: "POST",
                body: {
                    name: params.collectionName,
                    product_ids: params.productIds,
                },
            }),
            invalidatesTags: ["Collections"],
        }),
        updateCollection: builder.mutation<
            void,
            {
                collectionId: number;
                collectionName: string;
                productIds: number[];
            }
        >({
            query: (params) => ({
                url: `apiV2/dealer/collections/${params.collectionId}`,
                method: "PATCH",
                body: {
                    name: params.collectionName,
                    product_ids: params.productIds,
                },
            }),
            invalidatesTags: ["Collections"],
        }),
        deleteCollection: builder.mutation<void, number>({
            query: (collectionId) => ({
                url: `apiV2/dealer/collections/${collectionId}`,
                method: "DELETE",
            }),
            invalidatesTags: ["Collections"],
        }),
    }),
});

export const {
    useGetCollectionsQuery,
    useLazyGetCollectionsQuery,
    useDeleteCollectionMutation,
    useUpdateCollectionMutation,
    useCreateCollectionMutation,
} = collectionsApiSlice;
